import React     from 'react';
import PropTypes from 'prop-types'
import TextComponent from './base/TextComponent';

const ProjectRevision = (props) => {
  const onChange = (event) => props.onChangeParameter('revision', event.target.value);
  return (
    <TextComponent
      {...props}
      inputClassName={props.className}
      value={props.parameters.revision || ''}
      onChange={onChange}
      name="revision"
      groupName={props.groupName}
      required={props.required}
      error={props.error} />
  );
};

ProjectRevision.defaultProps = {
  required: true,
  inputId: 'revision',
  placeholder: 'Revision',
  groupName: undefined,
  error: undefined,
  className: undefined,
  label: '',
};

ProjectRevision.propTypes = {
  required: PropTypes.bool,
  inputId: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChangeParameter: PropTypes.func.isRequired,
  groupName: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  parameters: PropTypes.shape({ revision: PropTypes.string }).isRequired,
}

export default ProjectRevision;
